import request from '@/utils/request'
// 获取站点
export function listWebSite(query) {
  return request({
    url: '/portal/sysinfoList',
    method: 'get',
    params: query
  })
}


// 查询轮播
export function listBanner(query) {
  return request({
    url: '/portal/bannerList',
    method: 'get',
    params: query
  })
}

// 查询艺术家
export function listArtist(query) {
  return request({
    url: '/portal/artistList',
    method: 'get',
    params: query
  })
}

// 艺术详情
export function artistInfo(query) {
  return request({
    url: '/portal/artist',
    method: 'get',
    params: query
  })
}



// 获取展览
export function listExhibition(query) {
  return request({
    url: '/portal/exhibitionList',
    method: 'get',
    params: query
  })
}

// 获取展览详情
export function exhibitionInfo(query) {
  return request({
    url: '/portal/exhibition',
    method: 'get',
    params: query
  })
}

// 获取作品

export function opusList(query) {
  return request({
    url: '/portal/opusList',
    method: 'get',
    params: query
  })
}

// 获取博览会
export function listExposition(query) {
  return request({
    url: '/portal/expositionList',
    method: 'get',
    params: query
  })
}
// 获取博览会详情
export function expositionInfo(query) {
  return request({
    url: '/portal/exposition',
    method: 'get',
    params: query
  })
}
// 获取视野
export function listVision(query) {
  return request({
    url: '/portal/visionList',
    method: 'get',
    params: query
  })
}
// 获取视野详情
export function visionInfo(query) {
  return request({
    url: '/portal/vision',
    method: 'get',
    params: query
  })
}

export function searchList(query) {
  return request({
    url: '/portal/search',
    method: 'get',
    params: query
  })
}
// 上传


export function upLoad(data) {
  return request({
    url: '/portal/downloadArtistOpus',
    headers: {
      'responseType': 'arraybuffer',
      'Content-Type': 'application/pdf',
    },
    method: 'post',
    data
  })
}





